const sharedSettings = {
  type: { editable: true, type: 'select', rules: [{ required: true, options: [
    { value: 0, label: 'Good' },
    { value: 1, label: 'Bad' },
  ] }] },

  name: { editable: true, type: 'input', rules: [{ required: false }] },

  category: { editable: true, type: 'hm-category-select', rules: [{ required: false }] },
  subcategory: { editable: true, type: 'hm-subcategory-select', rules: [{ required: false }] },

  is_pre_filling: { editable: true, type: 'switch', rules: [{ required: false }] },

  created_at: { hidden: true },
  updated_at: { hidden: true },

  area: { hidden: true },
  area_name: { hidden: true },
  area_user_type: { hidden: true },

  category_name: { hidden: true },
  subcategory_name: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  type: 0,
  name: "",
  category: null,
  subcategory: null,
};
